import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";

class TillRepositoryForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-4">
                        <Select objectValue={false} name="till" value={ this.props.values.till } labelKey="displayname" component="Till" storeType="local" saveChanges={this.props.setFieldValue}
                                label="Eladási pont" {...this.props.getFieldProps("till")}/>
                    </div>
                    <div className="col-md-4">
                        <Select objectValue={false} name="moneyrepository" value={ this.props.values.moneyrepository } valueKey="repository_id" labelKey="name" component="MoneyRepository" storeType="local" saveChanges={this.props.setFieldValue}
                                label="Pénztár" {...this.props.getFieldProps("moneyrepository")}/>
                    </div>
                    <div className="col-md-4">
                        <Select objectValue={false} name="paymentmethod" value={ this.props.values.paymentmethod } optionname="paymentprovider" storeType="local" saveChanges={this.props.setFieldValue}
                                label="Fizetés módja" {...this.props.getFieldProps("paymentprovider")}/>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(TillRepositoryForm);
